import { Component, OnInit, Input, ViewChild, Output, EventEmitter, SimpleChange, AfterViewInit, OnChanges } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/modal';
import { UsuariosService } from 'app/_services/usuarios.service';
import { CentrosDeTrabajoService } from 'app/_services/centrosdetrabajo.service';

declare var jQuery: any;


@Component({
  selector: 'modaladminusuarioscts',
  templateUrl: './modaladminusuarioscts.component.html',
  styleUrls: ['./modaladminusuarioscts.component.css']
})
export class ModaladminusuariosctsComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() _mostrarmodal: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;
  @Output() onChangeModal = new EventEmitter<any>();
  @Input() _id_empresa: any;  

  public filterQueryUsuarios = "";
  public filterQueryCentros = "";

  mostrarmodal: boolean = false;
  filtroCentros: boolean =false;
  filtroUsuarios: boolean =false;
  seleccionadosTodos: boolean = false;
  seleccionadosTodosUsuarios:boolean = false;

  listausuariosseleccionados: any = [];
  listausuarios: any = []; 
  listaUsuariosFiltered:any = []; 
  listaUsuariosChecked:any = [];


  listacentros: any = [];
  listaCentrosFiltered: any = [];
  listaCentrosChecked:any = [];

  centrodetrabajoseleccionado: any [];  
  listacentrosseleccionados: any = [];
  constructor( private usuariosService: UsuariosService,
              private centrosdetrabajoService: CentrosDeTrabajoService) { }


  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }

    this.getListaUsuarios();
    this.getListaCentrosDeTrabajo();
  }

  ngOnInit() {
 
  }

  ngAfterViewInit(){
    this.abrirModal();
  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(guardar: boolean){
    if (!guardar){
      this.listausuariosseleccionados = [];
      this.listacentrosseleccionados = [];
    }
    this.staticModalRespuestas.hide();

    let emit = {
      centros: this.listacentrosseleccionados,
      usuarios: this.listausuariosseleccionados
    }

    this.onChangeModal.emit(emit);

  }  

  getListaUsuarios(){
    console.log('pasa');
    this.usuariosService.getListaUsuarios().subscribe(
        data => {
          if (data){
            this.listausuarios = data.json().lista;
            this.listaUsuariosFiltered = data.json().lista;
            console.log(this.listausuarios);
          }
        }
    );
  }  

  getListaCentrosDeTrabajo(){
    this.centrosdetrabajoService.getListaCentrosDeTrabajoEmpresa(this._id_empresa).subscribe(
        data => {
          if (data){
            this.listacentros = data.json().lista;
            this.listaCentrosFiltered = data.json().lista;
      //      console.log(this.listacentros);
      //      console.log(this.listaCentrosFiltered);
          }
        }
    );
  }


  anadirUsuario(usuario: any, event: any,index: number){

    let encontrado: number;

    if (jQuery('#check_'+event).is(':checked')) {
      this.listausuariosseleccionados.push(usuario);
      this.listaUsuariosChecked[event] = event ;
      

    }else{
      for (let i = 0; i < this.listausuariosseleccionados.length; i++) {
        if (this.listausuariosseleccionados[i].id_usuario == usuario.id_user){
          encontrado = i;
        }

      }

      this.listausuariosseleccionados.splice(encontrado,1);
      const index: number = this.listaUsuariosChecked.indexOf(event);

      if (index !== -1) {
          this.listaUsuariosChecked[index] = null;
      }  
    }

    console.log(this.listausuariosseleccionados);
//    console.log(this.listaUsuariosChecked);
  }

  
  anadirCentro(centro: any, event: any){

    let encontrado: number;
    if (jQuery('#checkct_'+event).is(':checked')) {
      this.listacentrosseleccionados.push(centro);
      this.listaCentrosChecked[event] = event ;
      
    }else{
      for (let i = 0; i < this.listacentrosseleccionados.length; i++) {
        if (this.listacentrosseleccionados[i].id_ct == centro.id_ct){
          encontrado = i;
        }

      }

      this.listacentrosseleccionados.splice(encontrado,1);
      const index: number = this.listaCentrosChecked.indexOf(event);

      if (index !== -1) {
          this.listaCentrosChecked[index] = null;
      }       
    }

    console.log(this.listacentrosseleccionados);
    console.log(this.listaCentrosChecked);

  }


  anadirTodosCentros(centro: any, event: any){

    if (!jQuery('#checkct_'+event).is(':checked')) {
      jQuery('#checkct_'+event).prop("checked", true);
 
      this.listacentrosseleccionados.push(centro);
      this.listaCentrosChecked[event] = event ;
     
    }

    console.log(this.listacentrosseleccionados);

  }


  seleccionarTodosCentros(){

    this.seleccionadosTodos = true;

    if (this.filtroCentros){
      console.log('con filtros');
      for (let listaTodosCentros of this.listaCentrosFiltered){
        this.anadirTodosCentros(listaTodosCentros,listaTodosCentros.id_ct);
      }
    }else{
      console.log('sin filtros');
      for (let listaTodosCentros of this.listacentros){
        this.anadirTodosCentros(listaTodosCentros,listaTodosCentros.id_ct);
      }
    }

  }

  quitarTodosCentros(){
 
    this.seleccionadosTodos = false;
  
    for (let listaTodosCentros of this.listacentros){
      jQuery('#checkct_'+listaTodosCentros.id_ct).prop("checked", false);

      this.listacentrosseleccionados = [];
      this.listaCentrosChecked= [];
    } 
  }


  filterCentroItems(ev: any) {
    
    if (this.seleccionadosTodos || this.listacentrosseleccionados.length > 0){
      this.quitarTodosCentros();
    }

    this.filtroCentros = true;

    let val = ev.target.value;
    
    if (val && val !== '') {
       this.listaCentrosFiltered = this.listacentros.filter((item) => {
        return (item.denominacion.toLowerCase().includes(val.toLowerCase()) || item.provincia.toLowerCase().includes(val.toLowerCase()) || item.municipio.toLowerCase().includes(val.toLowerCase()));
      });
    }else{
      this.getListaCentrosDeTrabajo();
      this.filtroCentros = false;
    }
    /*
    console.log('********************');
    console.log(this.listacentros);
    console.log(this.listaCentrosFiltered);
    console.log('********************');
    */
 
  }

  
  anadirTodosUsuarios(usuario: any, event: any){

    if (!jQuery('#check_'+event).is(':checked')) {
      jQuery('#check_'+event).prop("checked", true);
 
      this.listausuariosseleccionados.push(usuario);
      this.listaUsuariosChecked[event] = event ;
    }

    console.log(this.listausuariosseleccionados);

  }

  seleccionarTodosUsuarios(){

    this.seleccionadosTodosUsuarios = true;

    if (this.filtroUsuarios){
      console.log('con filtros');
      for (let listaTodosUsuarios of this.listaUsuariosFiltered){
        this.anadirTodosUsuarios(listaTodosUsuarios,listaTodosUsuarios.id_user);
      }
    }else{
      console.log('sin filtros');
      for (let listaTodosUsuarios of this.listausuarios){
        this.anadirTodosUsuarios(listaTodosUsuarios,listaTodosUsuarios.id_user);
      }
    }

  }

  quitarTodosUsuarios(){
 
    this.seleccionadosTodosUsuarios = false;
  
    for (let listaTodosUsuarios of this.listausuarios){
      jQuery('#check_'+listaTodosUsuarios.id_user).prop("checked", false);
      this.listausuariosseleccionados = [];
      this.listaUsuariosChecked = [];
    } 
  }

  filterUsuarioItems(ev: any) {
    
    if (this.seleccionadosTodosUsuarios || this.listausuariosseleccionados.length > 0){
      this.quitarTodosUsuarios();
    }

    this.filtroUsuarios = true;

    let val = ev.target.value;
    
    if (val && val !== '') {
       this.listaUsuariosFiltered = this.listausuarios.filter((item) => {
        return (item.nombre.toLowerCase().includes(val.toLowerCase()) || item.apellidos.toLowerCase().includes(val.toLowerCase()) 
              || item.email.toLowerCase().includes(val.toLowerCase()) || item.nfiscal.toLowerCase().includes(val.toLowerCase())  );
      });
    }else{
      this.getListaUsuarios();
      this.filtroUsuarios = false;
    }
/*    
    console.log('********************');
    console.log(this.listausuarios);
    console.log(this.listaUsuariosFiltered);
    console.log('********************');
 */
  }

}



// WEBPACK FOOTER //
// ./src/app/modaladminusuarioscts/modaladminusuarioscts.component.ts